// @flow

export { default as DropZone, fileExtentsion, processFile, processFilesFromDrop } from './DropZone';
export type { FileSelectionMethod, RejectionReason } from './DropZone';
export {
  maxImageUploadSizeInMB,
  maxImageUploadSizeInBytes,
  maxVideoUploadSizeInBytes,
} from './types';
export type { FileType } from './types';
